/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BlockType, TextType } from "@vienna/common";

import { ConvertibleBlockType } from "src/classes/block/block-types";
import {
  CodeBlockIcon,
  ColorBlockIcon,
  HeadingIcon,
  ImageBlockIcon,
  MonoBlockIcon,
  QuoteBlockIcon,
  TextBlockIcon,
} from "src/components/UI/Icons";

export interface SlashMenuOption {
  name: string;
  blockType: ConvertibleBlockType | BlockType.Text;
  subtype?: TextType;
  icon: JSX.Element;
  description: string;
}

export const SLASH_MENU_OPTIONS: SlashMenuOption[] = [
  {
    name: "Text",
    blockType: BlockType.Text,
    subtype: TextType.Plain,
    icon: <TextBlockIcon />,
    description: "Write anything in plain text",
  },
  {
    name: "Heading 1",
    blockType: BlockType.Text,
    subtype: TextType.H1,
    icon: <HeadingIcon />,
    description: "Add a large section heading",
  },
  {
    name: "Heading 2",
    blockType: BlockType.Text,
    subtype: TextType.H2,
    icon: <HeadingIcon />,
    description: "Add a medium section heading",
  },
  {
    name: "Image",
    blockType: BlockType.Image,
    icon: <ImageBlockIcon />,
    description: "Upload or embed an image",
  },
  {
    name: "Color",
    blockType: BlockType.Color,
    icon: <ColorBlockIcon />,
    description: "Choose from millions of colors",
  },
  {
    name: "Mono",
    blockType: BlockType.Text,
    subtype: TextType.Mono,
    icon: <MonoBlockIcon />,
    description: "Write with monospace font",
  },
  {
    name: "Code",
    blockType: BlockType.Code,
    icon: <CodeBlockIcon />,
    description: "Insert a code block",
  },
  {
    name: "Quote",
    blockType: BlockType.Text,
    subtype: TextType.Quote,
    icon: <QuoteBlockIcon />,
    description: "Insert quote",
  },
];
